import React, { useMemo } from "react";
import { Typography, Flex, Grid } from "antd";
import SharedFooter from "../../../components/DataTableFooter/SharedFooter";
import "./productReplace.css"

const { useBreakpoint } = Grid;

const sum = (arr, fn) => arr.reduce((s, x) => s + (fn(x) || 0), 0);

const ProductReplaceFooter = ({
    authInfo,
    givenItems,
    returnItems,
    footerValues,
    onFooterChange,
    defaultAccount
}) => {
    const screens = useBreakpoint();

    const amounts = useMemo(() => {
        const returnAmount = sum(returnItems, (r) => Number(r.quantity || 0) * Number(r.rate || 0));
        const givenAmount = sum(givenItems, (g) => Number(g.quantity || 0) * Number(g.rate || 0));
        return { returnAmount, givenAmount, total: givenAmount - returnAmount };
    }, [givenItems, returnItems]);

    return (
        <Flex
            className="product-replace-footer"
            vertical={!screens.md}     // stack on mobile
            gap={24}
            style={{ width: "100%", marginTop: 32 }}
        >
      {/* <Flex vertical gap={12} style={{ width: "50%" }}>        
        <Flex justify="space-between" align="center">
          <Col style={{ width: "60%" }}><Text>Return Amount :</Text></Col>
          <Col style={{ width: "20%", textAlign: "right" }}>
            <Text>£{amounts.returnAmount.toFixed(2)}</Text>
          </Col>
        </Flex>
        <Flex justify="space-between" align="center">
          <Col style={{ width: "60%" }}><Text>Given Item Amount :</Text></Col>
          <Col style={{ width: "20%", textAlign: "right" }}>
            <Text>£{amounts.givenAmount.toFixed(2)}</Text>
          </Col>
        </Flex>
        <Flex justify="space-between" align="center">
          <Col style={{ width: "60%" }}><Text strong>Total :</Text></Col>
          <Col style={{ width: "20%", textAlign: "right" }}>
            <Text strong>£{amounts.total.toFixed(2)}</Text>
          </Col>
        </Flex>
      </Flex> */}

      <div className="footer-section">
                <SharedFooter
                    footerValues={footerValues}
                    onFooterChange={onFooterChange}
                    dataSource={[...returnItems, ...givenItems]}
                    pageType="productReplace"
                />
            </div>
        </Flex>
    );
};

export default ProductReplaceFooter;